// extracted by mini-css-extract-plugin
export var card = "_jy-5";
export var cardSelected = "_jy-4";
export var image = "_jy-3";
export var modal = "_jy-0";
export var modalContent = "_jy-1";
export var table = "_jy-2";